import script from "./DebriefDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./DebriefDetails.vue?vue&type=script&setup=true&lang=js"

import "./DebriefDetails.vue?vue&type=style&index=0&id=8954ea22&lang=css"

const __exports__ = script;

export default __exports__